module.exports = __webpack_public_path__ + "a996630f129691c85f61413da63d4ab8.png";